import Query from '../../components/Report';

const query = ({ offset = 0, author = '' }) =>
    new Query('discover-single-author-entities', { offset, author });
export default query;
